import './CardResource.css'

function CardResource() {
    return (
        <>

            <li className="card-resource">
                <a href="/">
                    <span className="badge text-s">
                        <span className="text-s text-white">
                            new
                        </span>
                        Start selling online.
                    </span>
                    <h3 className="text-md text-white">
                        Award-winning collection. Install any demo or template with a single click.
                    </h3>
                </a>
            </li>

        </>
    );
}

export default CardResource;